import { Auth } from 'aws-amplify'
import { apiCall, secondaryApi } from './ApiUtils'

export const USER_FORM = {
    given_name: "",
    family_name: "",
    email: ""
}

export const modifyUsers = (token, newUsers, overwrite = false, oldUsers = {}) => {
    let userPromises = []
    newUsers.forEach(user => {
        if (user.userId) {
            delete oldUsers[user.userId]
            userPromises.push(Promise.resolve({}))
        } else {
            userPromises.push(apiCall('user', {
                method: 'POST',
                body: user
            }, token))
            
        }
    })

    if(overwrite){

        for (let userId in oldUsers) {
            userPromises.push(apiCall(`user/${userId}`, { 
                method: 'DELETE'
            }, token))
        }
    }

    return Promise.all([...userPromises])
}

export const postUser = (user) => apiCall('user', {
    method: 'POST',
    body: user
}, null)

export const updateUser = (token, user) => apiCall(`user/${user.userId}`, { 
    method: 'PUT',
    body: user
}, token)

export const deleteUser = (userId) => apiCall(`user/${userId}`, {
    method: 'DELETE'
})

export const getUsers = (siteId) => apiCall(`sites/${siteId}/users`, {
    method: 'GET',
}, null, secondaryApi)


export const getOrgByUser = (token) => apiCall(`users/org`, {
    method: 'GET',
}, token,secondaryApi)

export const checkUserExists = (email, status=null) => apiCall(`users/exist${status ? ("/"+status): ""}`, {
    method: 'POST',
    body: {email}
}, null,secondaryApi)

export const verify = (key) => apiCall(`verify/${key}`, {
    method: 'GET'
}, null)

export const alertNoAccountProperties = () => apiCall(`users/ga-alert`, {
    method: 'POST'
}, null, secondaryApi)

export const getMe = (token) => apiCall(`me`, {
    method: 'GET'
}, token)

export const getOAuthToken = (token, tokenId) => apiCall(`token/${tokenId}`, {
    method: 'GET'
}, token)

export const getAllUsers = (lastEvalKey=null, filterText=null) => apiCall(`users${lastEvalKey ? "?lastEvalKey="+lastEvalKey : ""}${filterText ? "?filterText="+filterText : ""}`, {
    method: 'GET'
}, null, secondaryApi)

export const getImpersonationAccess = (email) => apiCall(`admin/user/impersonate`,{
    method: 'POST',
    body: {
        username: email
    }
}, null,secondaryApi)